import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { FarmSettings, FarmSettingsModuleState } from '../../models/farm-settings.model';
import * as sustainabilitySettingsActions from '../actions/farm-settings.actions';

export const adapter: EntityAdapter<FarmSettings> = createEntityAdapter<FarmSettings>({});

export const initialState = <FarmSettingsModuleState>{
  enableCO2Calculation: false,
};

const farmSettingsReducer = createReducer(
  initialState,
  on(sustainabilitySettingsActions.loadFarmSettingsSuccess, (state, { farmSettings }) => ({
    ...state,
    id: farmSettings.id,
    enableCO2Calculation: farmSettings.enableCO2Calculation,
  })),
  on(sustainabilitySettingsActions.upsertFarmSettingsSuccess, (state, { farmSettings }) => ({
    ...state,
    id: farmSettings.id,
    enableCO2Calculation: farmSettings.enableCO2Calculation,
  })),
);

export function reducer(state: FarmSettingsModuleState | undefined, action: Action) {
  return farmSettingsReducer(state, action);
}
